import { StartEvent } from './StartEvent';
import { EndEvent } from './EndEvent';
import { UserTask } from './UserTask';
import { ServiceTask } from './ServiceTask';
import { ScriptTask } from './ScriptTask';
import { ManualTask } from './ManualTask';
import { ExclusiveGateway } from './ExclusiveGateway';
import { ParallelGateway } from './ParallelGateway';
import { InclusiveGateway } from './InclusiveGateway';
import { ComplexGateway } from './ComplexGateway';
import { EventBasedGateway } from './EventBasedGateway';
import { IntermediateEvent } from './IntermediateEvent';
import { BoundaryEvent } from './BoundaryEvent';
import { IntermediateThrowEvent } from './IntermediateThrowEvent';
import { SendTask } from './SendTask';
import { ReceiveTask } from './ReceiveTask';
import { BusinessRuleTask } from './BusinessRuleTask';
import { CallActivity } from './CallActivity';
import { SubProcess } from './SubProcess';
import { Transaction } from './Transaction';
import { Participant } from './Participant';
import { Lane } from './Lane';
import { DataObjectReference } from './DataObjectReference';
import { DataStoreReference } from './DataStoreReference';
import { Group } from './Group';
import { TextAnnotation } from './TextAnnotation';

export const SHAPES = [
  StartEvent,
  EndEvent,
  UserTask,
  ServiceTask,
  ScriptTask,
  ManualTask,
  SendTask,
  ReceiveTask,
  BusinessRuleTask,
  CallActivity,
  ExclusiveGateway,
  ParallelGateway,
  InclusiveGateway,
  ComplexGateway,
  EventBasedGateway,
  IntermediateEvent,
  IntermediateThrowEvent,
  BoundaryEvent,
  SubProcess,
  Transaction,
  Participant,
  Lane,
  DataObjectReference,
  DataStoreReference,
  Group,
  TextAnnotation,
];

export function registerShapes(lf) {
  SHAPES.forEach(({ type, view, model }) => {
    lf.register({ type, view, model });
  });
}
